"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronLeftIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const ChevronLeftIcon = props => {
    const { style } = props, otherProps = __rest(props, ["style"]);
    const svgStyle = Object.assign({ transition: 'color 0.3s, background-color 0.3s' }, style);
    return (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({ style: svgStyle }, otherProps, { viewBox: "0 0 24 24" }),
        react_1.default.createElement("path", { transform: "translate(24 0) rotate(90)", d: "M16.6 8L12 12.6L7.4 8L6 9.4L12 15.4L18 9.4L16.6 8Z" })));
};
exports.ChevronLeftIcon = ChevronLeftIcon;
exports.default = exports.ChevronLeftIcon;
